<template>
    <div id="ChangeMobile">

       <div class="g-right-middle width800 g-ypxx">
       	<p>
       		<span class='ypxx-left'>手机号</span>
       		<span class="ypxx-right">
				<input type="text"  v-model="mobile" placeholder="请输入您的新手机号">
			</span>
			<div class="clearfix"></div>
		</p>
		<p>
			<span class='ypxx-left'>验证码</span>
			<span class="ypxx-right">
				<input v-model="code"  style="width: 250px;" type="text" placeholder="请输入手机验证码" />
				<input @click="send(mobile)" class="yzm-btn" type="button" value="发送验证码">
			</span>
			<div class="clearfix"></div>
		</p>

			<center><input @click="updateInfo" type="button" class="g-btn" value="确认提交"></center>
		</div>
    </div>
</template>
<script>
	import Axios from 'axios'
	import storage from '../../../storage/storage.js'
	export default{
		data(){
			return{
				//picture:'',
				mobile:'',
				code:''

			}
		},
		methods:{
			send(mobile) {
				var api = "https://api.yopoo.cn/api/v1/code?mobile=" + mobile;
				if (mobile == "") {
					this.$message({     //提示信息
						message: '请输入手机号！',
						type: 'success',
						center:true

					});
				} else {
					this.$http.get(api).then(
						(res) => {
							// console.log(res);
							this.$message({     //提示信息
								message: res.data.msg,
								type: 'success',
								center:true

							});


						},
						err => {
							console.log(err);
						}
					);
				}
			},
			updateInfo(){
				var api='https://api.yopoo.cn/api/centre//updateMobile'
				let updateinfo={
					mobile:this.mobile,
					code:this.code
				}
				Axios.post(api,updateinfo).then((res)=>{
					// console.log(res.data)

					if(res.data.code=='200'){
						this.$message({     //提示信息
							message: res.data.msg,
							type: 'success',
							center:true

						});
						storage.clear()
						setTimeout(() => {
								this.$router.push(

									{path:'/login',
									} //据说是验证是否需要权限的东西，待验证
								)   //登录后跳转页面
							}, 2000);
						}


					else{

					}
				}).catch((res)=>{

				})
			}
		}
	}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/per_admin/change/P_ChangeMobile.vue